export const otkaz_ugovora_o_radu_na_zahtjev_radnika = {
  templateId: 7,
  category: 1,
  templateTitle: "Redoviti otkaz ugovora o radu na zahtjev radnika",
  templateDescription: `<p>Otkaz (u ovom slučaju, od strane radnika) jedan je od načina prestanka radnog odnosa.</p>`,
  description: `
    <h5>OPIS  DOKUMENTA</h5>
    <p>Redoviti otkaz (u ovom slučaju, od strane radnika)  jedan je od načina prestanka radnog odnosa.</p>
    <p>Otkaz predstavlja jednostranu izjavu volje, u ovom slučaju radnika.</p>
    <p>Ukoliko radnik daje redoviti otkaz, za to nije potreban nikakav razlog.</p>
    <p><strong>Ugovor o radu sklopljen na određeno vrijeme može se redovito otkazati samo ako je takva mogućnost otkazivanja predviđena ugovorom.</strong></p>
    <p>Ukoliko radnik otkazuje ugovor o radu redovitim otkazom, otkazni rok ne može biti duže od mjesec dana, osim ako radnik za to ima osobito važan razlog.</p>
    <p><strong>U slučaju kad radnik daje otkaz, otkazni rok smatra se zaštitnim instrumentom u korist poslodavca, npr. od poremećaja u poslovanju zbog odlaska radnika. Da bi odricanje od otkaznog roka od strane poslodavca bilo zakonski valjano, otkazni rok radnika mora početi teći (otkazni rok počinje teći nakon uručenja otkaza).</strong></p>

    <p>Radni odnos prestaje istekom otkaznog roka.</p>
    
    <h5>SVRHA DOKUMENTA</h5>
    <p>Prestanak radnog odnosa izjave radnike uz otkazni rok u kojemu je radnik dužan i dalje raditi za poslodavca, ukoliko se ugovorne strane ne dogovore drugačije. Radni odnos prestaje istekom otkaznog roka.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- pretpostavka da ova vrsta otkaza omogućuje radniku pravo na naknadu za nezaposlene osobe koju bi mogao ostvariti pri Hrvatskom zavodu za zapošljavanje</strong></p>
    <p>Pojašnjenje: ukoliko je radni odnos prestao otkazom radnika, radnik nema pravo na novčanu naknadu s Hrvatskog zavoda zapošljavanje.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu, Ugovor o radu.</p>
  `,

  sides: [
    {
      prefix: "Na temelju odredaba Zakona o radu i Ugovora o radu, ja,",
      signature: "Radnik:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
  ],

  headline: "neopozivo dajem sljedeći",
  title: "REDOVITI OTKAZ UGOVORA O RADU",

  noArticleNumbers: true,
  articles: [
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Ovom izjavom dajem redoviti otkaz na ugovora o radu na određeno vrijeme sklopljenog dana" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine, s Poslodavcem",},
                { type: "input", value: "", required: true },
                { type: "text", content: "", help: "Ugovor o radu sklopljen na određeno vrijeme može se redovito otkazati samo ako je takva mogućnost otkazivanja predviđena ugovorom." },
              ]
            }, 
            {
              parts: [
                { type: "text", content: "Ovom izjavom dajem redoviti otkaz ugovora o radu na neodređeno vrijeme sklopljenog dana" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine, s Poslodavcem" },
                { type: "input", value: "", required: true },
                { type: "text", content: "" },
              ]
            }],
        },
      ]
    },
    {
      title: "",
      mandatory: false,
      statements: [{
        type: "text",
        mandatory: true,
        editable: true,
        content: "Izjavljujem da osim plaće te prava na godišnji odmor nemam drugih potraživanja prema Poslodavcu koja bi proizlazila iz radnog odnosa."
      }]
    },
    {
      title: "",
      mandatory: true,
      statements: [{
        type: "text",
        mandatory: true,
        editable: false,
        content: "Zahtijevam da mi radni odnos prestane nakon isteka otkaznog roka.",
      }]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
    {
      static: true,
      mandatory: true,
      editable: true,
      type: 4, 
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Otkazni rok počinje teći uručenjem otkaza poslodavcu.",
          content: "\r\nPoslodavac svojim potpisom na ovom otkazu potvrđuje da je isti zaprimio dana ____________ godine.\r\n\r\nZa poslodavca: ____________________ , dana _______________ godine. "
          },
        ],
      },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/7_otkaz_ugovora_o_radu_na_zahtjev_radnika.ts